import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { CreditChargeService } from '@tokeet-frontend/billing'
import { Toaster, SaveForm, ActionFailed, positive } from '@tokeet-frontend/tv3-platform'
import { MessagingSettingsService } from 'libs/message/src/lib/store/settings/service'

@Component({
  selector: 'app-sms-auto-credit-recharge',
  templateUrl: './sms-auto-credit-recharge.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class SMSAutoCreditRechargeComponent implements OnInit {
  settingsForm = this.fb.group({
    recharge_balance: [undefined, [positive(), Validators.required]],
    recharge_threshold: [undefined, [positive(), Validators.required]],
  })
  rechargeForm = this.fb.group({
    recharge_amount: [50, [Validators.min(5), Validators.required]],
  })
  isRecharging = false

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    private toaster: Toaster,
    private messagingService: MessagingSettingsService,
    private creditChargeService: CreditChargeService
  ) {}

  ngOnInit(): void {
    this.messagingService.getSettings().subscribe((data) => {
      const defaultData = {
        recharge_balance: 50,
        recharge_threshold: 10,
      }
      this.settingsForm.patchValue(data || defaultData)
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const payload = this.settingsForm.getRawValue()
    this.messagingService.updateSettings(payload).subscribe(
      () => {
        this.toaster.success($localize`Settings updated successfully!`)
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  @SaveForm()
  onCharge(form: FormGroup) {
    this.isRecharging = true
    const payload = this.rechargeForm.getRawValue()
    this.creditChargeService.messagingRecharge(payload.recharge_amount).subscribe(
      () => {
        this.isRecharging = false
        this.toaster.success($localize`Recharged successfully!`)
      },
      (error) => {
        this.isRecharging = false
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }
}
